module.exports = __webpack_public_path__ + "static/img/restauration.a5b506d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/restauration.jpg
// module id = anwo
// module chunks = 1